import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Label,
	FormGroup,
	Form,
	Input,
	Container,
	Row,
	Col,
	Modal
} from "reactstrap";

// core components
import WhiteNavbar from "../components/Navbars/WhiteNavbar";
import db from "../db"
import Select from "react-select"
import { Link } from "react-router-dom"
import { LoadingScreen } from "../components/MiscFunctions"

// Email Js
import { init } from 'emailjs-com';
import emailjs from "emailjs-com"
// user id
init("user_prAS48Vb0QRmVzQznt2GB");

function ContactUs() {
	document.documentElement.classList.remove("nav-open");

	const [categories, setCategories] = useState([])
	useEffect(() => db.EventCategories.listenAll(setCategories), [])

	const [categoryOptions, setCategoryOptions] = useState([])
	useEffect(() => setCategoryOptions(categories.map((option) => { return { value: option, label: option.name } })), [categories])

	const [name, setName] = useState("")
	const [email, setEmail] = useState("")
	const [subject, setSubject] = useState("")
	const [message, setMessage] = useState("")
	const [category, setCategory] = useState(null)
	const [robot, setRobot] = useState(false)

	const [contact, setContact] = useState(null)
	useEffect(() => db.Contacts.listenByField(setContact, "isDisplayed", true), [])

	const validate = () =>
		name.length > 0 &&
		subject.length > 0 &&
		message.length > 0 &&
		category.value &&
		robot &&
		/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)

	const send = () => {
		emailjs.send(
			// service id
			"service_contactUs",
			// template id
			"template_contactUs",
			{
				subject,
				name,
				category: category.value.name,
				email,
				message
			}
		).then(() => {
			setSuccessModal(true)
		}, (e) => {
			console.log(e);
			setFailModal(true)
		})

		reset()
	}

	const reset = () => {
		setName("")
		setEmail("")
		setSubject("")
		setMessage("")
		setCategory(null)
		setRobot(false)
	}

	const [successModal, setSuccessModal] = useState(false);
	const [failModal, setFailModal] = useState(false);

	return (
		<>
			{
				contact && contact[0] ?
					<>
						<WhiteNavbar />
						<div className="section section-contactus cd-section fullBg" id="contact-us">
							<div className="contactus-2" style={{ paddingTop: "0" }}>
								<div className="big-map" id="contactUsMap2">
									<iframe
										style={{
											width: "100%",
											height: "100%",
											frameborder: "0",
											border: "0",
											right: "0",
										}}
										className="fullBg"
										title="map"
										src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBxv2Y4IQTGlaS4384SvkyihIa3yIYzXwE&q=Smart+Event+and+Production,Doha+Qatar"
										allowFullScreen
									>
									</iframe>
								</div>
								{
									categories && contact ?
										<Container>
											<Row>
												<div style={{ paddingLeft: "50%" }}>
												</div>
												<Col md="6">
													<Card className="card-contact card-raised">
														<CardHeader className="header-raised header-primary text-center ">
															<CardTitle tag="h4" >Contact Us</CardTitle>
														</CardHeader>
														<Form id="contact-form2" method="post" role="form">
															<CardBody>
																<Row>
																	<Col md="6">
																		<div className="info info-horizontal">
																			<div className="icon icon-info">
																				<i className="nc-icon nc-badge" />
																			</div>
																			<div className="description">
																				<h5 style={{ color: "#000000" }}>Give us a call</h5>
																				<p style={{ color: "#000000" }}>
																					{contact[0].repName} <br />
																					{contact[0].phone} <br />
																					{contact[0].opening}
																				</p>
																			</div>
																		</div>
																	</Col>
																	<Col md="6">
																		<div className="info info-horizontal">
																			<div className="icon icon-danger">
																				<i className="nc-icon nc-pin-3" />
																			</div>
																			<div className="description">
																				<h5 style={{ color: "#000000" }}>
																					Find us at the office
																				</h5>
																				<p style={{ color: "#000000" }}>
																					{contact[0].location}
																				</p>
																			</div>
																		</div>
																	</Col>
																</Row>
																<Row>
																	<Col md="6">
																		<FormGroup>
																			<label className="control-label">Full Name</label>
																			<Input
																				name="name"
																				placeholder="Full name"
																				type="text"
																				value={name}
																				onChange={(e) => setName(e.target.value)}
																			/>
																		</FormGroup>
																	</Col>
																	<Col md="6">
																		<FormGroup>
																			<label className="control-label">Email address</label>
																			<Input
																				name="email"
																				placeholder="Email"
																				type="email"
																				value={email}
																				onChange={(e) => setEmail(e.target.value)}
																			/>
																		</FormGroup>
																	</Col>
																</Row>
																<Row>
																	<Col md="12">
																		<FormGroup>
																			<label className="control-label">Service</label>
																			<Select
																				className="react-select react-select-default border-input"
																				name="category"
																				value={category}
																				onChange={(value) => setCategory(value)}
																				options={categoryOptions}
																				placeholder={(category && category.label) || "Choose Category"}
																			/>
																		</FormGroup>
																	</Col>
																</Row>
																<Row>
																	<Col md="12">
																		<FormGroup>
																			<label className="control-label">Subject</label>
																			<Input
																				name="subject"
																				placeholder="Subject"
																				type="text"
																				value={subject}
																				onChange={(e) => setSubject(e.target.value)}
																			/>
																		</FormGroup>
																	</Col>
																</Row>
																<FormGroup>
																	<label className="control-label">Your message</label>
																	<Input
																		id="messages"
																		name="message"
																		placeholder="Message"
																		type="textarea"
																		rows="6"
																		value={message}
																		onChange={(e) => setMessage(e.target.value)}
																	/>
																</FormGroup>
																<Row>
																	<Col md="6">
																		<FormGroup check>
																			<Label check>
																				<Input
																					type="checkbox"
																					value={robot}
																					onChange={() => setRobot(!robot)}
																				/>
                                                            						I'm not a robot !{" "}
																				<span className="form-check-sign" />
																			</Label>
																		</FormGroup>
																	</Col>
																	<Col md="6">
																		<Button
																			className="btn-rose pull-right"
																			color="success"
																			onClick={(e) => {
																				e.preventDefault()
																				send()
																			}}
																			disabled={!validate()}
																		>
																			Send Message
                                                						</Button>
																	</Col>
																</Row>
															</CardBody>
														</Form>
													</Card>
												</Col>
											</Row>
										</Container>
										:
										<LoadingScreen />
								}
							</div>
							{/* Modals */}
							<Modal
								size="sm"
								isOpen={successModal}
								toggle={() => setSuccessModal(false)}
							>
								<div className="modal-body text-center">
									<h3>Message Sent!</h3>
								</div>
								<Button
									className="btn-success"
									color="success"
									type="button"
									onClick={() => setSuccessModal(false)}
									tag={Link}
									to="/"
								>
									Ok
                						</Button>
							</Modal>
							<Modal
								size="sm"
								isOpen={failModal}
								toggle={() => setFailModal(false)}
								style={{ minWidth: "50vw" }}
							>
								<Card>
									<CardHeader>
										<div className="modal-body text-center">
											<h5>
												Sorry something went wrong. <br />
												Send us an email at <br />
												smarteventproduction@smarteventproduction.com <br />
												or call us at 5072 1234
											</h5>
										</div>
									</CardHeader>
									<Button
										className="btn-success"
										color="success"
										type="button"
										onClick={() => setFailModal(false)}
									>
										Ok
									</Button>
								</Card>
							</Modal>
						</div>
					</>
					:
					<LoadingScreen />
			}
		</>
	);
}

export default ContactUs;
